import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import Badge from "react-bootstrap/Badge";
import Alert from "react-bootstrap/Alert";

import "bootstrap/dist/css/bootstrap.min.css";

const KsefUpdate0308 = () => {
  return (
    <Container className="mt-4 mb-5">
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <h2 className="m-0">Оновлення KSeF 03.08</h2>
        <Badge bg="success">Реалізовано</Badge>
      </div>
      <p className="text-muted">
        Велике оновлення сторінки «KSeF — фактури»: локальний дамп завантажених фактур, вибір місяця замість
        тижня, фільтри Online/Offline і «на сайті», звірка з усіма фактурами на сайті по брутто та VAT,
        прив&apos;язка будь-якої фактури до водія вручну та позначка «оброблено».
      </p>

      <Alert variant="warning">
        <b>Перед деплоєм на прод:</b> виконати SQL-міграції{" "}
        <code>server/migrations/create_ksef_invoice_cache.sql</code> та{" "}
        <code>server/migrations/alter_ksef_invoice_cache_processed.sql</code> (друга — якщо таблиця дампу вже
        існувала без колонки <code>is_processed</code>), після чого перезапустити сервер. Без цих таблиць дамп
        і позначка «оброблено» не працюватимуть.
      </Alert>

      <Alert variant="info">
        <b>Коротко:</b> один раз завантажили місяць з KSeF — далі можна відкривати той самий список із локального
        дампу без повторного запиту. Кожну фактуру можна вручну прив&apos;язати до водія. Система показує, чи на
        сайті вже є фактура з таким же брутто і VAT (у т.ч. завантажена з кабінету водія). Опрацьовані рядки
        можна позначити «оброблено», щоб не повертатись до них знову.
      </Alert>

      <Accordion defaultActiveKey="0" alwaysOpen className="mb-4">
        <Accordion.Item eventKey="0">
          <Accordion.Header>1. Що змінилось</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <b>Вибір місяця замість тижня.</b> На сторінці «KSeF — фактури» тепер обираються місяць і рік —
                фактури дістаються за весь календарний місяць (дата виставлення).
              </li>
              <li>
                <b>Локальний дамп.</b> Після «Завантажити з KSeF» фактури зберігаються на сервері. Наступного разу
                можна натиснути <b>«Показати з дампу»</b> і працювати зі списком без нового запиту до KSeF.
              </li>
              <li>
                <b>Фільтр Online / Offline.</b> За режимом виставлення фактури в KSeF (
                <code>invoicingMode</code>).
              </li>
              <li>
                <b>Фільтр «на сайті».</b> Показати лише ті, що вже є / ще немає на сайті (звірка з базою).
              </li>
              <li>
                <b>Фільтр «оброблено».</b> За замовчуванням видно необроблені. Опрацьовані можна сховати або
                навпаки показати лише їх.
              </li>
              <li>
                <b>Звірка по брутто + VAT по всіх фактурах на сайті.</b> Система шукає збіги серед усіх водіїв
                (кабінет, адмін, інші джерела), а не лише по одному підказаному водію. Якщо збіг знайдено —
                жовтий бейдж і список кандидатів з кнопкою «Прив&apos;язати».
              </li>
              <li>
                <b>Прив&apos;язка будь-якої фактури до водія.</b> У кожному рядку є вибір водія і кнопка
                «Створити фактуру» — навіть якщо автозбігу немає. Автопідказка водія (номер авта / KSeF ID)
                лишається і підставляється в select, якщо знайдена.
              </li>
              <li>
                <b>Позначка «Оброблено».</b> Можна вручну позначити або зняти. Після створення або прив&apos;язки
                фактура позначається обробленою автоматично. Статус зберігається в дампі і не губиться при
                повторному завантаженні з KSeF.
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>2. Як було раніше</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Фільтр був лише по тижню — для місячного огляду доводилось робити кілька завантажень.</li>
              <li>Кожне відкриття списку знову тягнуло дані з KSeF (повільно й зайві запити до API).</li>
              <li>Створити фактуру можна було лише якщо система сама знайшла водія.</li>
              <li>Звірка «на сайті» не враховувала повноцінно брутто+VAT по всіх фактурах / кабінету.</li>
              <li>Не було способу позначити переглянуту фактуру як оброблену в списку KSeF.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>3. Інструкція — робота зі сторінкою після оновлення</Accordion.Header>
          <Accordion.Body>
            <ol>
              <li>
                Перейти в <b>«Рахунки» → «KSeF — фактури»</b> (
                <code>/admin/ksef</code>).
              </li>
              <li>Обрати <b>місяць</b> і <b>рік</b>. Під полями видно діапазон дат і скільки фактур уже в дампі.</li>
              <li>
                Якщо дамп уже є — натиснути <b>«Показати з дампу»</b>. Якщо потрібні свіжі дані з KSeF —{" "}
                <b>«Завантажити з KSeF (і зберегти дамп)»</b> (може зайняти до 1–2 хв).
              </li>
              <li>
                За потреби увімкнути фільтри: Online/Offline, «на сайті» / «ще немає», необроблені / оброблені.
              </li>
              <li>
                У колонці <b>«На сайті»</b>:{" "}
                <Badge bg="success">Вже є</Badge> — уже прив&apos;язана по KSeF ID;{" "}
                <Badge bg="warning" text="dark">
                  Збіг брутто/VAT ×N
                </Badge>{" "}
                — на сайті є фактура(и) з тими ж сумами (можна прив&apos;язати);{" "}
                <Badge bg="light" text="dark">
                  Немає
                </Badge>{" "}
                — на сайті ще немає.
              </li>
              <li>
                Щоб додати фактуру: обрати водія в списку (або лишити автопідказку) →{" "}
                <b>«Створити фактуру»</b>. Якщо під рядком є кандидати з кабінету — краще спочатку{" "}
                <b>«Прив&apos;язати»</b>, щоб не створити дублікат.
              </li>
              <li>
                Коли фактура опрацьована (створена, прив&apos;язана або просто не потрібна) — натиснути{" "}
                <b>«Оброблено»</b>. Зняти позначку можна кнопкою «Зняти &quot;оброблено&quot;».
              </li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>4. Звірка з фактурами на сайті (брутто + VAT)</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                Порівняння йде по <b>усіх</b> рядках <code>driver_invoices</code> (усі водії, джерела: кабінет,
                адмін, KSeF).
              </li>
              <li>
                Збіг рахується, якщо збігаються <b>брутто і VAT</b> (точність до 0.01 PLN). Якщо з одного боку
                VAT немає — звірка лише по брутто.
              </li>
              <li>
                Точний збіг по номеру KSeF показується окремо як <Badge bg="success">Вже є</Badge>.
              </li>
              <li>
                Під рядком видно водія, суми, статус, джерело і кнопку прив&apos;язки (якщо в кандидата ще немає
                ksef_number).
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>5. Який буде результат</Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>Менше повторних запитів до KSeF — список місяця можна відкривати з дампу.</li>
              <li>Зручніше опрацьовувати великий обсяг: місяць, фільтри, позначка «оброблено».</li>
              <li>Менше дублікатів з кабінету водія завдяки звірці по брутто + VAT.</li>
              <li>Будь-яку фактуру з KSeF можна вручну прив&apos;язати до потрібного водія.</li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default KsefUpdate0308;
